import { WifiHigh, WifiSlash, ArrowCircleDown } from '@phosphor-icons/react'
import { useOfflineStatus } from '../hooks/useOfflineStatus'

export function OfflineIndicator() {
  const { isOnline, isOfflineReady } = useOfflineStatus()

  if (!isOnline) {
    return (
      <div className="offline-indicator offline-indicator--offline" role="status" aria-live="polite">
        <WifiSlash size={16} weight="bold" />
        <span>Offline mode — using cached content</span>
      </div>
    )
  }

  if (isOfflineReady) {
    return (
      <div className="offline-indicator offline-indicator--ready" role="status" aria-live="polite">
        <ArrowCircleDown size={16} weight="bold" />
        <span>Offline ready</span>
      </div>
    )
  }

  return (
    <div className="offline-indicator offline-indicator--online" role="status" aria-live="polite">
      <WifiHigh size={16} weight="bold" />
      <span>Online</span>
    </div>
  )
}
